import { getActorLabel, getPhaseDetail } from '../../domain/phaseStatus';
import { DOMAIN_PHASE_LABELS } from '../../constants/phaseLabels';
import { useGameStore } from '../../store/gameStore';

export function PhaseBanner() {
  const game = useGameStore((s) => s.game);
  const botActingPlayerIndex = useGameStore((s) => s.botActingPlayerIndex);
  const { phase, round } = game;

  const phaseLabel = DOMAIN_PHASE_LABELS[phase] ?? phase;
  const phaseDetail = getPhaseDetail(game);
  const actorLabel = getActorLabel(game, botActingPlayerIndex);
  const isBotActing = botActingPlayerIndex !== null;

  return (
    <div className="overlay-panel px-4 py-3 text-center">
      <p className="text-xs uppercase tracking-[0.2em] text-amber-200/80">
        {round > 0 ? `라운드 ${round} · ${phaseLabel}` : phaseLabel}
      </p>
      {phaseDetail && (
        <p className="mt-1 text-sm font-medium text-white/90">{phaseDetail}</p>
      )}
      {actorLabel && (
        <p
          className={`mt-1 text-sm font-semibold ${
            isBotActing ? 'animate-pulse text-amber-300' : 'text-amber-100'
          }`}
        >
          {actorLabel}
        </p>
      )}
      {!actorLabel && game.message && (
        <p className="mt-1 text-xs text-white/70">{game.message}</p>
      )}
    </div>
  );
}
